import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import MeetingsManager from '../../../components/admin/appointments/MeetingsManager';

function AdminBillingRendezVousPage() {
  return (
    <AdminLayout title="Rendez-vous (Facturation)">
      <MeetingsManager strictAdmin={true} />
    </AdminLayout>
  );
}

export default AdminBillingRendezVousPage;
